export const selectPrefetchKeys = (state) => state.services.discovery.prefetch;

export const selectBlockMessage = (state) => state.services.discovery?.blockMessage;

export const selectLockdown = (state) => state.services.discovery.lockdown;

export const selectTargetEnv = (state) => state.services.discovery.targetEnv;
